export default __webpack_public_path__ + "static/media/watch.67b117c3.svg";